module.exports = __webpack_public_path__ + "media/dogs/dogs-with-credit-card-2ab5b195.svg";